import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AfterLoginPathGuard } from '@pw-utils/guards/after-login-path/after-login-path.guard';
import { AuthGuard } from '@pw-utils/guards/auth/auth.guard';
import { SupportGuard } from '@pw-utils/guards/support/support.guard';
import { UnAuthGuard } from '@pw-utils/guards/un-auth/un-auth.guard';
import { PublicLayoutComponent } from './components/public-layout/public-layout.component';

const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'accept-terms',
        canActivate: [AuthGuard, SupportGuard],
        data: { needAdminAccess: false, loginPath: '/login', unSupportPath: '/not-supported' },
        loadChildren: () =>
          import('@utils/src/lazy-modules/accept-terms/accept-terms.module').then((m) => m.AcceptTermsModule),
      },
      {
        path: 'login',
        canActivate: [UnAuthGuard, SupportGuard, AfterLoginPathGuard],
        data: { redirectPath: '/main/dashboard', unSupportPath: '/not-supported' },
        loadChildren: () => import('../../page-modules/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'not-supported',
        loadChildren: () =>
          import('@utils/src/lazy-modules/not-supported/not-supported.module').then((m) => m.NotSupportedModule),
      },
      { path: '**', redirectTo: 'login' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicLayoutRoutingModule {}
